(function () {
    'use strict';

    angular
        .module('app.commonPageDetail')
        .factory('commonPageDetailService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function updateCommonPage(params, loader) {
                    var url_updateCommonPage = $rootScope.apiUrl + 'admin/updateCommonPage';
                    return handleRequest(url_updateCommonPage, 'POST', params, loader);
                }

                service.updateCommonPage = updateCommonPage;

                return service;
            }
        ]);
})();
